import { twMerge } from "tailwind-merge";

interface FormFieldLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const FormFieldLayout: React.FC<FormFieldLayoutProps> = ({
  children,
  className,
}) => {
  return <div className={twMerge("flex flex-col", className)}>{children}</div>;
};
